:host {
  display: inline-block;
}

svg {
  width: 100%;
  height: auto;
  display: block;
}

svg.inherit-fill {
  fill: inherit;

}

.logo-svg .cls-1{
  fill:#fff;
}

.logo-svg .cls-2{
  fill: #666;
}